<template>
  <el-form>
    <el-row
      :gutter="15"
    >
      <el-form-item
        label="DG Item Type"
        class="mb-2"
        :loading="isLoading"
      >
        <el-select
          v-model="dg.type"
          filterable
          placeholder="Search"
        >
          <el-option
            v-for="item in dgItems"
            :key="item.id"
            :label="item.itemdg_propname"
            :value="item.id"
          />
        </el-select>
      </el-form-item>
    </el-row>
    <el-row :gutter="15">
      <el-col
        :span="18"
      >
        <el-form-item
          label="Description"
          class="mb-2"
        >
          <el-input
            v-model="dg.description"
            placeholder="Description"
          />
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item
          label="Weight"
          class="mb-2"
        >
          <el-input
            v-model="dg.weight"
            placeholder="Weight"
          />
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</template>
<script>
export default {
  prop: {
    accountId: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      dg: {},
      isLoading: false,
      dgItems: []
    }
  },
  created () {
    // this.loadDG()
  },
  methods: {
    loadDG () {
      this.isLoading = true
      this.$sdk.account_itemsdg.list(builder => {
        builder.context = { resource: 'account', id: this.accountId }
        builder.limit = 1000
        builder.order = 'itemdg_propname:asc'
      })
        .then(res => {
          this.dgItems = res
        })
        .finally(() => { this.isLoading = false })
    }
  }
}
</script>
